import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { journeyStages } from '../../data/journey';
interface JourneyStagesProps {
  current: number;
  currentProgress?: number;
}
export function JourneyStages({
  current,
  currentProgress = 0
}: JourneyStagesProps) {
  return <ol className="grid grid-cols-5 gap-1.5" aria-label="Your mortgage journey" data-id="element-530" data-mp="1wt94nmt9jb4e">
      {journeyStages.map((s, i) => {
      const done = i < current;
      const active = i === current;
      const fill = done ? 100 : active ? Math.max(6, currentProgress) : 0;
      return <li key={s.id} className="min-w-0" aria-current={active ? 'step' : undefined} data-id="element-531" data-mp="2kk4vaglzg0a2" data-mpi={i}>
            <div className="h-1.5 overflow-hidden rounded-full bg-ink-200" data-id="element-532" data-mp="2fk8qwg9di6tz">
              <motion.div className={`h-full rounded-full ${done ? 'bg-pulse-300' : 'bg-pulse-600'}`} initial={{
            width: 0
          }} animate={{
            width: `${fill}%`
          }} transition={{
            duration: 0.8,
            ease: [0.23, 1, 0.32, 1],
            delay: 0.1 + i * 0.05
          }} data-id="element-533" data-mp="q5u4w3pqoy26" />
            </div>
            <div className={`mt-2.5 flex items-center gap-1 text-[11px] font-medium sm:text-[13px] ${active ? 'text-ink-900' : done ? 'text-ink-500' : 'text-ink-400'}`} data-id="element-534" data-mp="13w44oq66fh5s">
              {done && <CheckIcon className="hidden h-3.5 w-3.5 text-pulse-600 sm:block" aria-hidden data-id="element-535" data-mp="1dmff8vkd8oln" />}
              <span className="truncate" data-id="element-536" data-mp="1im1zhoym353y">{s.label}</span>
            </div>
          </li>;
    })}
    </ol>;
}